import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class BackgroundBlockerControl extends AbstractControl implements Control {

    private sprite: PIXI.Sprite;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.sprite = layer.getSprite(assetName);
        if (this.sprite) {
            this.sprite.interactive = true;
        }
    }

    public destroy() {
        if (this.sprite) {
            this.sprite.destroy();
        }
    }
}
